import _styled from "@emotion/styled-base";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";

import PropTypes from "prop-types";
import { rem } from "polished";
import { constants } from "../../styles";

var IconComponent = _styled("i", {
  target: "e11c20nv0",
  label: "IconComponent"
})(function (_ref) {
  var color = _ref.color,
      customColor = _ref.customColor,
      theme = _ref.theme,
      size = _ref.size;
  return "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font: normal normal normal 14px/1 FontAwesome;\n  text-rendering: auto;\n  font-style: normal;\n  font-size: " + rem(theme.typography.icons[size]) + ";\n  color: " + (customColor || theme.colors[color]) + ";\n";
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb24vSWNvbi5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXNCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb24vSWNvbi5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCB7IHJlbSB9IGZyb20gXCJwb2xpc2hlZFwiO1xuaW1wb3J0IHsgY29uc3RhbnRzIH0gZnJvbSBcIi4uLy4uL3N0eWxlc1wiO1xuXG5jb25zdCBJY29uQ29tcG9uZW50ID0gc3R5bGVkLmkoXG4gICh7IGNvbG9yLCBjdXN0b21Db2xvciwgdGhlbWUsIHNpemUgfSkgPT4gYFxuICAtd2Via2l0LWZvbnQtc21vb3RoaW5nOiBhbnRpYWxpYXNlZDtcbiAgLW1vei1vc3gtZm9udC1zbW9vdGhpbmc6IGdyYXlzY2FsZTtcbiAgZm9udDogbm9ybWFsIG5vcm1hbCBub3JtYWwgMTRweC8xIEZvbnRBd2Vzb21lO1xuICB0ZXh0LXJlbmRlcmluZzogYXV0bztcbiAgZm9udC1zdHlsZTogbm9ybWFsO1xuICBmb250LXNpemU6ICR7cmVtKHRoZW1lLnR5cG9ncmFwaHkuaWNvbnNbc2l6ZV0pfTtcbiAgY29sb3I6ICR7Y3VzdG9tQ29sb3IgfHwgdGhlbWUuY29sb3JzW2NvbG9yXX07XG5gXG4pO1xuXG5JY29uQ29tcG9uZW50LmRpc3BsYXlOYW1lID0gXCJJY29uXCI7XG5cbmNvbnN0IEljb24gPSAoeyBpY29uLCBjbGFzc05hbWUsIC4uLnByb3BzIH0pID0+IChcbiAgPEljb25Db21wb25lbnQgY2xhc3NOYW1lPXtgJHtpY29ufSAke2NsYXNzTmFtZSAmJiBjbGFzc05hbWV9YH0gey4uLnByb3BzfSAvPlxuKTtcblxuY29uc3QgeyBYUywgU00sIE1ELCBMRywgWEwgfSA9IGNvbnN0YW50cy5zaXplcztcbmNvbnN0IHsgUFJJTUFSWSwgU0VDT05EQVJZLCBTVUNDRVNTLCBXQVJOSU5HLCBEQU5HRVIsIEdSQVkgfSA9IGNvbnN0YW50cy5jb2xvcnM7XG5cbkljb24ucHJvcFR5cGVzID0ge1xuICBpY29uOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgc2l6ZTogUHJvcFR5cGVzLm9uZU9mKFtYUywgU00sIE1ELCBMRywgWExdKSxcbiAgY29sb3I6IFByb3BUeXBlcy5vbmVPZihbXG4gICAgbnVsbCxcbiAgICBQUklNQVJZLFxuICAgIFNFQ09OREFSWSxcbiAgICBTVUNDRVNTLFxuICAgIFdBUk5JTkcsXG4gICAgREFOR0VSLFxuICAgIEdSQVlcbiAgXSksXG4gIGN1c3RvbUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5JY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgY2xhc3NOYW1lOiBcIlwiLFxuICBzaXplOiBTTSxcbiAgY29sb3I6IG51bGwsXG4gIGN1c3RvbUNvbG9yOiBudWxsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBJY29uO1xuIl19 */");

IconComponent.displayName = "Icon";

var Icon = function Icon(_ref2) {
  var icon = _ref2.icon,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["icon", "className"]);

  return React.createElement(IconComponent, _extends({ className: icon + " " + (className && className) }, props));
};

var _constants$sizes = constants.sizes,
    XS = _constants$sizes.XS,
    SM = _constants$sizes.SM,
    MD = _constants$sizes.MD,
    LG = _constants$sizes.LG,
    XL = _constants$sizes.XL;
var _constants$colors = constants.colors,
    PRIMARY = _constants$colors.PRIMARY,
    SECONDARY = _constants$colors.SECONDARY,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING,
    DANGER = _constants$colors.DANGER,
    GRAY = _constants$colors.GRAY;


Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([XS, SM, MD, LG, XL]),
  color: PropTypes.oneOf([null, PRIMARY, SECONDARY, SUCCESS, WARNING, DANGER, GRAY]),
  customColor: PropTypes.string
};

Icon.defaultProps = {
  className: "",
  size: SM,
  color: null,
  customColor: null
};

export default Icon;